module.exports = __webpack_public_path__ + "static/media/linkbanner_sm2.23799404.png";